// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { CButton } from "@coreui/react-pro";
import { useEffect, useState } from "react";

const SelectItemOperation = ({
  text,
  selected,
  operation,
  segment,
  name,
  value,
  onClick = (segment, operation, tag) => void 0,
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const [props, setProps] = useState({ variant: "outline" });

  useEffect(() => {
    let seg = segment;
    if (operation) {
      seg = `${segment}:${operation}`;
    }

    if (Object.hasOwn(selected, seg) && selected[seg].includes(value ?? name.toLowerCase())) {
      setIsSelected(true);

      setProps({});
    } else {
      setIsSelected(false);
      setProps({ variant: "outline" });
    }
  }, [selected, segment, name]);

  return (
    <span style={{ display: "block" }}>
      <CButton
        size={"sm"}
        color={"success"}
        title={text}
        {...props}
        onClick={() => onClick(segment, operation, value ?? name.toLowerCase())}
        data-feature={"segment-operation"}
        data-segment-name={segment}
        data-option={name}
        data-operation={operation}
        data-state={isSelected}
      >
        &nbsp; &nbsp;
      </CButton>
    </span>
  );
};

export default SelectItemOperation;
